import { handleRequest } from ".";
import { httpAuthorized } from "@/main";

/** 全局默认计算参数项（管理端"默认参数"页签） */
export interface SysConfigItem {
  configKey: string;
  configValue: string;
  cname: string;
  unit: string;
  description: string;
  updaterId: string;
  createtime: string;
  updatetime: string;
}

/** 船舶参数视图（管理端"船舶参数"页签，svc_ship_config 快照 + 默认值对照） */
export interface ShipConfigShip {
  shipId: string;
  shipName: string;
  /** 该船各参数当前值（缺 key 已由后端回填默认值） */
  values: Record<string, string>;
  /** 被管理端修改过的参数 key（updater_id 非空） */
  customizedKeys: string[];
  /** 该船参数最后更新时间 */
  updatetime: string | null;
}

/** 查询全部默认参数 */
export const getSysConfigListApi = async (): Promise<
  SysConfigItem[] | null
> => {
  return handleRequest<SysConfigItem[]>(
    httpAuthorized.get("/sysConfig/list"),
    (data) => data.data.configs
  );
};

/** 修改指定默认参数值（仅对之后新建的船舶生效） */
export const updateSysConfigApi = async (
  configKey: string,
  configValue: string
): Promise<unknown | null> => {
  return handleRequest<unknown>(
    httpAuthorized.post("/sysConfig/update", { configKey, configValue }),
    (data) => data.data.result
  );
};

/** 查询全部船舶参数（含默认参数元数据做对照） */
export const getShipConfigListApi = async (): Promise<{
  defaults: SysConfigItem[];
  ships: ShipConfigShip[];
} | null> => {
  return handleRequest<{ defaults: SysConfigItem[]; ships: ShipConfigShip[] }>(
    httpAuthorized.get("/shipConfig/list"),
    (data) => ({
      defaults: data.data.defaults ?? [],
      ships: data.data.ships ?? [],
    })
  );
};

/** 修改指定船舶的参数（批量） */
export const updateShipConfigApi = async (
  shipId: string,
  items: { configKey: string; configValue: string }[]
): Promise<unknown | null> => {
  return handleRequest<unknown>(
    httpAuthorized.post("/shipConfig/update", { shipId, items }),
    (data) => data.data.result
  );
};

/** 恢复指定船舶参数为当前全局默认值 */
export const resetShipConfigApi = async (
  shipId: string
): Promise<unknown | null> => {
  return handleRequest<unknown>(
    httpAuthorized.post("/shipConfig/reset", { shipId }),
    (data) => data.data.result
  );
};

/** 恢复指定船舶的单个参数为默认值（货币恢复会联动单价；单价按该船币种换算默认） */
export const resetShipConfigKeyApi = async (
  shipId: string,
  configKey: string
): Promise<unknown | null> => {
  return handleRequest<unknown>(
    httpAuthorized.post("/shipConfig/resetKey", { shipId, configKey }),
    (data) => data.data.result
  );
};
